import React from 'react';
import pic25 from '../../assets/pic25.png'
import './selectinput.css'



const Selectinput = (props) => {
    return ( 


                            <fieldset className='selectt-container-input'>
                                     <label className='title-inputt'>{props.title}</label>
                                            
                                    <div className="select-wrapper">
                                        <img src={pic25} className="arrow-icon" alt="arrow" />

                                        <select
                                        className="input-select select-style"
                                        value={props.value}
                                        onChange={props.onChange}
                                        >
                                        <option value="">Select option</option>

                                        {props.options &&
                                            props.options.map((opt, index) => (
                                            <option key={index} value={opt.value}>
                                                {opt.label}
                                            </option>
                                            ))}
                                        </select>
                                    </div>
                                </fieldset>



     );
}
 
export default Selectinput;